document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("sticky-header");

  if (!header) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      header.classList.add("stickybar");
    } else {
      header.classList.remove("stickybar");
    }
  });
});




